import { track } from './analytics.js';

type SectionName = 'select' | 'subscribe';

export function showSection(name: SectionName): void {
  track('$pageview', { section: name });
  const subscribe = document.getElementById('subscribe');
  const backdrop = document.getElementById('subscribe-backdrop');

  if (name === 'subscribe') {
    if (subscribe) subscribe.hidden = false;
    if (backdrop) backdrop.hidden = false;
    const heading = subscribe?.querySelector<HTMLElement>('h1, h2');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: false });
    }
  } else {
    if (subscribe) subscribe.hidden = true;
    if (backdrop) backdrop.hidden = true;
    const select = document.getElementById('select');
    const heading = select?.querySelector<HTMLElement>('h1, h2');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: false });
    }
  }
}
